var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import TranscriptService from "../../../../Services/Transcript.service";
import useService from "../../../Hooks/useService";
import AcademicCalendarService from "../../../../Services/AcademicCalendar.service";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import TranscriptCourseCard from "../../../Presentational/TranscriptCourse/TranscriptCourseCard";
import useUniqueId from "../../../Hooks/useUniqueId";
import { AlertWarning } from "../../../UI/StandardAlerts/StandardAlerts";
import DeprecatedSelect from "../../../UI/DeprecatedSelect/DeprecatedSelect";
const AdvisorStudentsCourseTab = (props) => {
    const makeId = useUniqueId()[1];
    const [academicTermState, loadAcademicTerms] = useService(React.useMemo(() => (affiliationId) => TranscriptService.getTranscriptAcademicTerms(affiliationId).then((result) => 
    // This is kinda a flatMap.
    result.terms.reduce((sum, t) => {
        t.statuses.forEach((status) => {
            const { statuses } = t, otherAttributes = __rest(t, ["statuses"]);
            sum.push(Object.assign(Object.assign({}, otherAttributes), { status }));
        });
        return sum;
    }, [])), []));
    const [termOptions, setTermOptions] = React.useState();
    React.useEffect(() => {
        loadAcademicTerms(props.student.affiliationId).then((result) => {
            // If there's a current term, select that one, otherwise pick the first one.
            setTermOptions(result.find((t) => t.current) || result[0]);
        });
    }, [loadAcademicTerms, props.student.affiliationId]);
    const [termState, loadTerm] = useService(AcademicCalendarService.getTerm);
    React.useEffect(() => {
        if (termOptions && termOptions.status) {
            loadTerm(props.student.affiliationId, termOptions.status.academicCalendarId, termOptions.status.transcriptCourseStatusId);
        }
    }, [loadTerm, props.student.affiliationId, termOptions]);
    return (_jsxs(_Fragment, { children: [academicTermState.wasSuccessful &&
                academicTermState.data &&
                academicTermState.data.length === 0 ? (_jsx(AlertWarning, { message: "There are no courses for this person" })) : (_jsxs("div", { className: "d-flex w-100 align-items-center justify-content-end mb-3", children: [_jsx("label", { className: "sr-only", htmlFor: makeId("termControl"), children: "Term:" }), _jsx("div", { style: { width: 300 }, children: _jsx(DeprecatedSelect, { id: makeId("termControl"), "aria-label": "Term", isLoading: academicTermState.isLoading, options: academicTermState.data || [], optionRenderer: (option) => `${option.status.academicCalendarName} - ${option.status.transcriptCourseStatusName}`, 
                            // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
                            labelRenderer: (option) => `${option.status.academicCalendarName} - ${option.status.transcriptCourseStatusName}`, valueRenderer: (option) => `${option.status.academicCalendarName} - ${option.status.transcriptCourseStatusName}`, valueKey: "status", value: termOptions, searchable: false, clearable: false, onChange: setTermOptions }) })] })), _jsx(ServiceResult, { state: termState, errorMessage: "There was an error loading this term", children: (courses) => courses.length > 0 ? (_jsx("div", { className: "mb-5", children: courses.map((course, index) => (_jsx("div", { className: "mt-3", children: _jsx(TranscriptCourseCard, { course: course, student: props.student }) }, index))) })) : (_jsx(AlertWarning, { message: "There are no courses for this term" })) })] }));
};
export default AdvisorStudentsCourseTab;
